import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Something went wrong." };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("RAW_ERROR_BOUNDARY:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, message: "" });
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="error-boundary"
        className="min-h-screen text-white grid place-items-center p-6"
        style={{ background: "#050505" }}
      >
        <div className="max-w-md w-full border border-[#d4af37]/40 bg-[#050505] p-8">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#d4af37] mb-3">
            // SYSTEM_FAULT
          </div>
          <h1 className="font-display text-3xl mb-3">SOMETHING BROKE</h1>
          <p className="text-sm text-zinc-400 mb-6 font-mono break-words">
            {this.state.message}
          </p>
          <div className="flex gap-2 flex-wrap">
            <button
              data-testid="error-reload-btn"
              onClick={() => window.location.reload()}
              className="btn-raw btn-raw-primary"
            >
              ↻ RELOAD
            </button>
            <button
              data-testid="error-home-btn"
              onClick={this.reset}
              className="btn-raw"
            >
              ← GO HOME
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
